import { Component, OnInit } from '@angular/core';
import { TempleProfile } from '../model/temple-profile';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { TempleProfileService } from './temple-profile.service';
import { UtilsModule } from '@otas/utils/utils.module';
import { UserInfoWrapperComponent } from 'app/user-info-wrapper/user-info-wrapper.component';
@Component({
  selector: 'app-temple-profile',
  templateUrl: './temple-profile.component.html',
  styleUrls: ['./temple-profile.component.css'],
  providers: [TempleProfileService],
  imports: [UtilsModule, UserInfoWrapperComponent]
})
export class TempleProfileComponent implements OnInit {
  templeOwner = false;
  user;
  submitted = false;
  templeProfileForm: UntypedFormGroup;
  constructor(private fb: UntypedFormBuilder, private templeProfileService: TempleProfileService) {
    this.templeProfileForm = this.fb.group(new TempleProfile()
    );
  }

  ngOnInit() {
    const cookie = sessionStorage.getItem('CURRENT_USER');
    if (!!cookie) {

      this.user = JSON.parse(sessionStorage.getItem('CURRENT_USER'));

      this.templeProfileService.getTempleDetails(this.user.userId).subscribe((res) => {

        this.templeProfileForm.patchValue(res.result);

      });
      this.user.roles.forEach(element => {
        if (element.name === 'FULL_ACCESS') {
          this.templeOwner = true;
        }
      });
    }
  }
  updateProfile() {
    if (this.templeProfileForm.invalid) {
      this.submitted = true;
      return;
    }
    if (!this.user.hasTempleDetails) {
      this.templeProfileService.addProfile(this.templeProfileForm.value, this.user.userId).subscribe((res) => {
      });
    }
    if (this.user.hasTempleDetails) {
      this.templeProfileService.updateProfile(this.templeProfileForm.value, this.user.userId).subscribe((res) => {
      });
    }
  }

}
